import { isEmptyArray,
  isEmptyString,
  isNotEmptyString } from '@weft/utils';
import VyDialog from 'apps/app/src/components/new-design/feedback/VyDialog';
import { SuspenseBoundary } from 'apps/app/src/components/utility/SuspenseBoundary';
import { useContractPage } from 'apps/app/src/hooks/requests/pages/use-contract-page';
import { useExportNetSuiteSalesOrder, useUpdateNetSuiteSalesOrder } from 'apps/app/src/hooks/requests/use-net-suite';
import { runMutation } from 'apps/app/src/utils/vy-mutation';
import React, { useState } from 'react';
import { ContractProductsOverviewsContent } from './net-suite-export-contract-dialog-components/ContractProductsOverviewsContent';
import { SelectNetSuiteUsers } from './net-suite-export-contract-dialog-components/SelectNetSuiteUsers';

type NetSuiteExportContractDialogProps = {
  open: boolean;
  onClose: () => void;
  contractId: string;
  isSynced: boolean;
};

export const NetSuiteExportContractDialog: React.FC<
  NetSuiteExportContractDialogProps
> = ({ open, onClose, contractId, isSynced }) => {
  const [selectedProductsIds, setSelectedProductsIds] = useState<string[]>([]);
  const [selectedSubsidiary, setSelectedSubsidiary] = useState<string>('');
  
  const { data } = useContractPage(contractId);
  const erpId = data?.contractPageData.contract.customer.erpMetadata?.erpId;
  
  const netSuiteMutation = isSynced ? useUpdateNetSuiteSalesOrder : useExportNetSuiteSalesOrder;
  const exportToNetSuiteMutation = netSuiteMutation(contractId);

  const warningText = isNotEmptyString(erpId)
    ? 'Select at least one product item to create a sales order.'
    : 'ERP data is missing, check the customer and products NS settings.';
  
  const onSubmit = async () => {
    onClose();

    await runMutation(
      exportToNetSuiteMutation,
      {
        contractId,
        productsIds: selectedProductsIds,
        subsidiaryId: selectedSubsidiary,
      },
      {
        pending: 'Syncing...',
        success: 'Synced',
        error: 'Failed to sync',
      },
    );
  };

  return (
    <>
      <VyDialog
        open={open}
        onClose={onClose}
        label={isSynced ? 'Update Sales Order in ERP' : 'Sync Contract to ERP Sales Order'}
        labelDescription="Sync contract items into your ERP as a new sales order."
        warningText={warningText}
        warningColor={isEmptyString(erpId) ? '#D32F2F' : undefined}
        cancelButtonText="Cancel"
        ctaText="Sync order"
        ctaDisabled={
          isEmptyArray(selectedProductsIds) || isEmptyString(erpId) || isEmptyString(selectedSubsidiary)
        }
        onSubmit={onSubmit}
      >
        <SuspenseBoundary>

          <ContractProductsOverviewsContent
            contractId={contractId}
            onProductSelect={setSelectedProductsIds}
          />
          {isNotEmptyString(erpId) && (
            <SelectNetSuiteUsers
              erpId={erpId}
              onSubsidiarySelect={setSelectedSubsidiary}
            />
          )}
        </SuspenseBoundary>
      </VyDialog>
    </>
  );
};